import * as React from 'react'
import { useLocale, useTranslation, CarouselSection } from 'hooks'
import { withTranslations } from 'helpers'

import Carousel from '../../Carousel'
import * as S from './ProductHero.styles'

const ProductCarousels = ({ productId }: { productId: string }) => {
  const { t } = useTranslation()
  const { locale, currency, location } = useLocale()

  const carousels = [
    {
      title: t('shared.you_may_also_like'),
      section: 'related_products'
    },
    {
      title: t('shared.recently_viewed'),
      section: 'recently_viewed'
    }
  ]

  return (
    <S.CarouselContainer data-nosnippet>
      {carousels.map((i) => {
        return (
          <Carousel
            key={`${i}${i.title}`}
            title={i.title}
            section={i.section as CarouselSection}
            product_id={productId}
            currency={currency}
            locale={locale}
            delivery_location={location.code}
          />
        )
      })}
    </S.CarouselContainer>
  )
}

export default withTranslations(ProductCarousels)
